// import { useEffect, useRef, useState } from 'react';
// import { Modal, ModalActions, ModalNote } from '../../../components/ui/Modal/Modal';
// import { Button } from '../../../components/ui/Button/Button';
// import type { FaqForm, FaqItem } from '../../../entities/faq/model/types';
// import styles from './FaqModal.module.scss';
// import React from 'react';
// import Dropzone from '../../project/Dropzone/Dropzone';

// export interface FaqModalProps {
//     open: boolean;
//     source: FaqItem | null;
//     saving: boolean;
//     onClose: () => void;
//     onSubmit: (form: FaqForm) => void;
// }

// const EMPTY: FaqForm = { question: '', answer: '', file: null };

// export function FaqModal({ open, source, saving, onClose, onSubmit }: FaqModalProps) {
//     const [form, setForm] = useState<FaqForm>(EMPTY);
//     const fileRef = useRef<HTMLInputElement>(null);

//     useEffect(() => {
//         if (!open) return;
//         setForm(source ? { question: source.question, answer: source.answer, file: null } : EMPTY);
//         if (fileRef.current) fileRef.current.value = '';
//     }, [open, source]);

//     if (!open) return null;

//     const canSubmit = form.question.trim().length > 0 && form.answer.trim().length > 0 && !saving;

//     return (
//         <Modal
//             open
//             onClose={onClose}
//             width={600}
//             title={source ? 'Редактирование вопроса' : 'Новый вопрос'}
//             footer={
//                 <>
//                     <ModalNote>Вопрос увидят все пользователи в разделе "Часто задаваемые вопросы".</ModalNote>
//                     <ModalActions>
//                         <Button onClick={onClose}>Отмена</Button>
//                         <Button variant="primary" disabled={!canSubmit} onClick={() => onSubmit(form)}>
//                             {source ? 'Сохранить' : 'Добавить'}
//                         </Button>
//                     </ModalActions>
//                 </>
//             }
//         >
//             <label className={styles.field}>
//                 <span>Вопрос</span>
//                 <input
//                     value={form.question}
//                     onChange={(e) => setForm((prev) => ({ ...prev, question: e.target.value }))}
//                     placeholder="Как получить доступ для новой организации?"
//                 />
//             </label>

//             <label className={styles.field}>
//                 <span>Ответ</span>
//                 <textarea
//                     rows={6}
//                     value={form.answer}
//                     onChange={(e) => setForm((prev) => ({ ...prev, answer: e.target.value }))}
//                     placeholder="Переносы строк сохраняются."
//                 />
//             </label>

//             <div className={styles.field}>
//                 <span>Изображение</span>

//                 <Dropzone
//                     state={form.file ? 'success' : 'empty'}
//                     fileName={form.file?.name}
//                     title="Перетащите изображение"
//                     hint="Оно появится под ответом в разделе "Часто задаваемые вопросы"."
//                     formats="PNG, JPG до 5 МБ"
//                     onPickFile={() => fileRef.current?.click()}
//                     onDropFile={(file) => setForm((prev) => ({ ...prev, file }))}
//                 />

//                 <input
//                     ref={fileRef}
//                     type="file"
//                     accept="image/*"
//                     hidden
//                     onChange={(e) => setForm((prev) => ({ ...prev, file: e.target.files?.[0] ?? null }))}
//                 />

//                 {source?.images.length && !form.file ? (
//                     <small className={styles.hint}>
//                         Сейчас загружено изображение. Перетащите файл, чтобы заменить его.
//                     </small>
//                 ) : null}
//             </div>
//         </Modal>
//     );
// }


import { useEffect, useState } from 'react';
import { Modal, ModalActions, ModalNote } from '../../../components/ui/Modal/Modal';
import { Button } from '../../../components/ui/Button/Button';
import type { FaqForm, FaqItem } from '../../../entities/faq/model/types';
import styles from './FaqModal.module.scss';

export interface FaqModalProps {
    open: boolean;
    source: FaqItem | null;
    saving: boolean;
    onClose: () => void;
    onSubmit: (form: FaqForm) => void;
}

const EMPTY: FaqForm = { question: '', answer: '', file: null };

export function FaqModal({ open, source, saving, onClose, onSubmit }: FaqModalProps) {
    const [form, setForm] = useState<FaqForm>(EMPTY);

    useEffect(() => {
        if (!open) return;
        setForm(source ? { question: source.question, answer: source.answer, file: null } : EMPTY);
    }, [open, source]);

    if (!open) return null;

    const canSubmit = form.question.trim().length > 0 && form.answer.trim().length > 0 && !saving;

    return (
        <Modal
            open
            onClose={onClose}
            width={600}
            title={source ? 'Редактирование вопроса' : 'Новый вопрос'}
            footer={
                <>
                    <ModalNote>Вопрос увидят все пользователи в разделе "Часто задаваемые вопросы".</ModalNote>
                    <ModalActions>
                        <Button onClick={onClose}>Отмена</Button>
                        <Button variant="primary" disabled={!canSubmit} onClick={() => onSubmit(form)}>
                            {source ? 'Сохранить' : 'Добавить'}
                        </Button>
                    </ModalActions>
                </>
            }
        >
            <label className={styles.field}>
                <span>Вопрос</span>
                <input
                    value={form.question}
                    onChange={(e) => setForm((prev) => ({ ...prev, question: e.target.value }))}
                    placeholder="Как получить доступ для новой организации?"
                />
            </label>

            <label className={styles.field}>
                <span>Ответ</span>
                <textarea
                    rows={6}
                    value={form.answer}
                    onChange={(e) => setForm((prev) => ({ ...prev, answer: e.target.value }))}
                    placeholder="Переносы строк сохраняются."
                />
            </label>
        </Modal>
    );
}